import { useState } from 'react';
import AdminLayout from '../components/AdminLayout';
import ProductsPanel from './components/ProductsPanel';
import BrandsPanel from './components/BrandsPanel';
import NewsPanel from './components/NewsPanel';

type Tab = 'products' | 'brands' | 'news';

const tabs: { id: Tab; label: string; icon: string; desc: string }[] = [
  { id: 'products', label: '產品介紹', icon: 'ri-box-3-line', desc: '新增、編輯或下架產品項目' },
  { id: 'brands', label: '代理品牌', icon: 'ri-building-2-line', desc: '管理關於頁面顯示的代理品牌' },
  { id: 'news', label: '最新消息', icon: 'ri-newspaper-line', desc: '新增、編輯最新消息與公告' },
];

export default function AdminCatalogPage() {
  const [activeTab, setActiveTab] = useState<Tab>('products');
  const current = tabs.find(t => t.id === activeTab)!;

  return (
    <AdminLayout>
      {/* Page Header */}
      <div className="mb-5">
        <h1 className="text-xl font-bold text-[#1a2535]">內容管理</h1>
        <p className="text-xs text-gray-400 mt-0.5">{current.desc}</p>
      </div>

      {/* Tab Bar */}
      <div className="flex items-center gap-0 border-b border-gray-200 mb-5">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap border-b-2 -mb-px ${
              activeTab === tab.id
                ? 'border-[#1a73b5] text-[#1a73b5] bg-white'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={`${tab.icon} text-sm`} />
            </div>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'products' && <ProductsPanel />}
      {activeTab === 'brands' && <BrandsPanel />}
      {activeTab === 'news' && <NewsPanel />}
    </AdminLayout>
  );
}
